import { FC } from 'react';
import { TextField } from '@mui/material';
import { MdSearch } from 'react-icons/md';

const SearchLibraryInput: FC<
  React.PropsWithChildren<SearchLibraryInputProps>
> = ({ searchValue, onSearch }) => {
  return (
    <TextField
      size='small'
      value={searchValue}
      onChange={onSearch}
      id='search-apps'
      placeholder='openssl@3.0.0'
      sx={{
        minWidth: 400,
        mx: 1,
      }}
      InputProps={{
        endAdornment: <MdSearch />,
      }}
    />
  );
};

export interface SearchLibraryInputProps {
  searchValue: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default SearchLibraryInput;
